import React from "react";
import { DESTINATIONS } from "../../constants/destinations";

function ExplorePlaces({ places = DESTINATIONS, onSelect }) {
  return (
    <section className="mt-12">
      <div className="mb-6">
        <p className="text-sm uppercase tracking-widest text-blue-700/70 font-semibold">
          Explore
        </p>
        <h3 className="mt-1 text-2xl sm:text-3xl font-bold text-gray-900 font-poppins">
          Places to discover
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {places.map((p) => (
          <div
            key={p.key}
            className="group relative overflow-hidden rounded-3xl bg-white shadow-md ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
          >
            <div className="relative h-44">
              <img
                src={p.image}
                alt={p.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) =>
                  (e.target.src =
                    "https://via.placeholder.com/600x320?text=Destination")
                }
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3">
                <div className="inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-800 shadow-sm">
                  {p.location || "Victoria · Australia"}
                </div>
              </div>
            </div>
            <div className="p-4">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">{p.name}</h4>
              <p className="text-sm text-gray-600 mb-4">{p.blurb}</p>
              {onSelect && (
                <button
                  onClick={() => onSelect(p.name)}
                  className="w-full rounded-xl bg-blue-600 px-4 py-2.5 text-white font-semibold shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600/40 text-center block"
                >
                  Book Now
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ExplorePlaces;
